// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Accessibility Enhancements */
:root {
  /* Enhanced color contrast variables */
  --light-blue: #49c1f4;
  --light-blue-hover: #3ab0e3; /* Darker for hover states */
  --purple: #7761c1;
  --dark-purple: #322a52;
  --light-grey: #f9fdff;
  --white: #ffffff;
  --black: #000000;
  --dark-bg: #121212;
  --dark-card: #1e1e1e;
  --text-on-dark: #f0f0f0; /* Ensuring high contrast for text on dark backgrounds */
  --focus-outline: #49c1f4; /* Visible focus indicator */
}

/* Focus states for accessibility */
a:focus,
button:focus,
input:focus,
textarea:focus,
select:focus,
[tabindex]:focus {
  outline: 3px solid var(--focus-outline);
  outline-offset: 2px;
}

/* Skip to content link for keyboard users */
.skip-to-content {
  position: absolute;
  left: -9999px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

.skip-to-content:focus {
  position: fixed;
  top: 0;
  left: 0;
  width: auto;
  height: auto;
  padding: 10px 15px;
  background-color: var(--dark-purple);
  color: var(--white);
  z-index: 9999;
  font-weight: bold;
}

/* Improved button contrast */
.btn-primary {
  background: linear-gradient(90deg, var(--light-blue), var(--purple));
  color: var(--white);
  font-weight: 600;
}

.btn-secondary {
  background: transparent;
  color: var(--text-on-dark);
  border: 2px solid var(--light-blue);
  font-weight: 600;
}

/* Ensuring text contrast */
p, li, td, th, label, input, textarea, select {
  color: var(--text-on-dark);
}

/* Improved form field contrast */
.form-control {
  background-color: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.2);
  color: var(--white);
}

.form-control:focus {
  border-color: var(--light-blue);
  background-color: rgba(255, 255, 255, 0.15);
}

/* ARIA attributes for interactive elements */
[role="button"],
[role="tab"],
[role="menuitem"] {
  cursor: pointer;
}

/* Improved table accessibility */
.publications-table th {
  background-color: var(--dark-purple);
  color: var(--white);
  font-weight: 600;
}

.publications-table tr:nth-child(even) {
  background-color: rgba(255, 255, 255, 0.05);
}

/* Improved link underlines for better visibility */
a:not(.btn):not(.logo) {
  text-decoration: underline;
  text-underline-offset: 2px;
}

a:not(.btn):not(.logo):hover {
  text-decoration: underline;
  text-decoration-thickness: 2px;
}

/* Improved contrast for icons */
.feature-icon,
.service-icon,
.contact-icon {
  color: var(--light-blue);
  background-color: rgba(73, 193, 244, 0.1);
  padding: 10px;
  border-radius: 50%;
}

/* Responsive text sizing */
@media (max-width: 768px) {
  body {
    font-size: 16px;
  }
  
  h1 {
    font-size: 2rem;
  }
  
  h2 {
    font-size: 1.75rem;
  }
  
  h3 {
    font-size: 1.5rem;
  }
}

/* Improved keyboard navigation indicators */
nav ul li a:focus::after {
  width: 100%;
}

/* Ensuring sufficient touch target sizes for mobile */
@media (max-width: 768px) {
  nav ul li a,
  .btn,
  .form-control,
  .expand-info {
    padding: 12px;
    min-height: 44px;
    min-width: 44px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}

/* Reduced motion option for users with vestibular disorders */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.001ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.001ms !important;
    scroll-behavior: auto !important;
  }
}

/* High contrast mode support */
@media (forced-colors: active) {
  .btn-primary,
  .btn-secondary {
    border: 2px solid currentColor;
  }
  
  .feature-card,
  .service-card,
  .team-card,
  .testimonial-card {
    border: 1px solid currentColor;
  }
}
`, "",{"version":3,"sources":["webpack://./src/dashboard/accessibility.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,sCAAsC;EACtC,qBAAqB;EACrB,2BAA2B,EAAE,4BAA4B;EACzD,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB,EAAE,wDAAwD;EACjF,wBAAwB,EAAE,4BAA4B;AACxD;;AAEA,mCAAmC;AACnC;;;;;;EAME,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,oEAAoE;EACpE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,0BAA0B;AAC5B;;AAEA,iCAAiC;AACjC;EACE,0CAA0C;EAC1C,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA,6CAA6C;AAC7C;;;EAGE,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,mDAAmD;AACnD;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA,gCAAgC;AAChC;;;EAGE,wBAAwB;EACxB,yCAAyC;EACzC,aAAa;EACb,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,4CAA4C;AAC5C;EACE,WAAW;AACb;;AAEA,sDAAsD;AACtD;EACE;;;;IAIE,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;EACzB;AACF;;AAEA,8DAA8D;AAC9D;EACE;IACE,sCAAsC;IACtC,uCAAuC;IACvC,uCAAuC;IACvC,gCAAgC;EAClC;AACF;;AAEA,+BAA+B;AAC/B;EACE;;IAEE,8BAA8B;EAChC;;EAEA;;;;IAIE,8BAA8B;EAChC;AACF","sourcesContent":["/* Accessibility Enhancements */\n:root {\n  /* Enhanced color contrast variables */\n  --light-blue: #49c1f4;\n  --light-blue-hover: #3ab0e3; /* Darker for hover states */\n  --purple: #7761c1;\n  --dark-purple: #322a52;\n  --light-grey: #f9fdff;\n  --white: #ffffff;\n  --black: #000000;\n  --dark-bg: #121212;\n  --dark-card: #1e1e1e;\n  --text-on-dark: #f0f0f0; /* Ensuring high contrast for text on dark backgrounds */\n  --focus-outline: #49c1f4; /* Visible focus indicator */\n}\n\n/* Focus states for accessibility */\na:focus,\nbutton:focus,\ninput:focus,\ntextarea:focus,\nselect:focus,\n[tabindex]:focus {\n  outline: 3px solid var(--focus-outline);\n  outline-offset: 2px;\n}\n\n/* Skip to content link for keyboard users */\n.skip-to-content {\n  position: absolute;\n  left: -9999px;\n  top: auto;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n}\n\n.skip-to-content:focus {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: auto;\n  height: auto;\n  padding: 10px 15px;\n  background-color: var(--dark-purple);\n  color: var(--white);\n  z-index: 9999;\n  font-weight: bold;\n}\n\n/* Improved button contrast */\n.btn-primary {\n  background: linear-gradient(90deg, var(--light-blue), var(--purple));\n  color: var(--white);\n  font-weight: 600;\n}\n\n.btn-secondary {\n  background: transparent;\n  color: var(--text-on-dark);\n  border: 2px solid var(--light-blue);\n  font-weight: 600;\n}\n\n/* Ensuring text contrast */\np, li, td, th, label, input, textarea, select {\n  color: var(--text-on-dark);\n}\n\n/* Improved form field contrast */\n.form-control {\n  background-color: rgba(255, 255, 255, 0.1);\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  color: var(--white);\n}\n\n.form-control:focus {\n  border-color: var(--light-blue);\n  background-color: rgba(255, 255, 255, 0.15);\n}\n\n/* ARIA attributes for interactive elements */\n[role=\"button\"],\n[role=\"tab\"],\n[role=\"menuitem\"] {\n  cursor: pointer;\n}\n\n/* Improved table accessibility */\n.publications-table th {\n  background-color: var(--dark-purple);\n  color: var(--white);\n  font-weight: 600;\n}\n\n.publications-table tr:nth-child(even) {\n  background-color: rgba(255, 255, 255, 0.05);\n}\n\n/* Improved link underlines for better visibility */\na:not(.btn):not(.logo) {\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\na:not(.btn):not(.logo):hover {\n  text-decoration: underline;\n  text-decoration-thickness: 2px;\n}\n\n/* Improved contrast for icons */\n.feature-icon,\n.service-icon,\n.contact-icon {\n  color: var(--light-blue);\n  background-color: rgba(73, 193, 244, 0.1);\n  padding: 10px;\n  border-radius: 50%;\n}\n\n/* Responsive text sizing */\n@media (max-width: 768px) {\n  body {\n    font-size: 16px;\n  }\n  \n  h1 {\n    font-size: 2rem;\n  }\n  \n  h2 {\n    font-size: 1.75rem;\n  }\n  \n  h3 {\n    font-size: 1.5rem;\n  }\n}\n\n/* Improved keyboard navigation indicators */\nnav ul li a:focus::after {\n  width: 100%;\n}\n\n/* Ensuring sufficient touch target sizes for mobile */\n@media (max-width: 768px) {\n  nav ul li a,\n  .btn,\n  .form-control,\n  .expand-info {\n    padding: 12px;\n    min-height: 44px;\n    min-width: 44px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n/* Reduced motion option for users with vestibular disorders */\n@media (prefers-reduced-motion: reduce) {\n  * {\n    animation-duration: 0.001ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.001ms !important;\n    scroll-behavior: auto !important;\n  }\n}\n\n/* High contrast mode support */\n@media (forced-colors: active) {\n  .btn-primary,\n  .btn-secondary {\n    border: 2px solid currentColor;\n  }\n  \n  .feature-card,\n  .service-card,\n  .team-card,\n  .testimonial-card {\n    border: 1px solid currentColor;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
